/**
 * Implementation of monitor detail page
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React from 'react';
import { AiOutlineFieldTime } from 'react-icons/ai';
import { MdOutlineTimeline } from 'react-icons/md';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';
import WidgetCard from '../../../components/WidgetCard';

const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export default function MonitorDetail() {

  return (
    <div>
      <h1 className="text-2xl text-primary">Instatweet</h1>
      <p className="text-gray-600">https://instatweet.app</p>

      <div className="flex mt-5">
        <div className="bg-green-600 rounded-xl shadow p-5 mb-5 w-1/3 flex justify-center items-center">
          <span className="flex h-4 w-4 relative mr-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-white"></span>
          </span>
          <p className="text-center text-white text-2xl font-bold">LIVE</p>
        </div>
        <div className="bg-white rounded-xl shadow mb-5 ml-5 w-1/3">
          <WidgetCard name="1560ms" description="Latency" color="#f1c762" icon={<AiOutlineFieldTime />} />
        </div>
        <div className="bg-white rounded-xl shadow mb-5 ml-5 w-1/3">
          <WidgetCard name="99.97%" description="Uptime" color="#f12762" icon={<MdOutlineTimeline />} />
        </div>
        <div className="bg-white rounded-xl shadow mb-5 ml-5 w-1/3"></div>

      </div>

      <div className="mb-5 bg-white p-5 rounded-xl shadow">
        <h1 className="text-lg font-semibold">Uptime</h1>
        <BarChart
          width={1000}
          height={200}
          data={data}
          margin={{
            top: 30,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="pv"  stackId="a" fill="darkgreen" maxBarSize={20} style={{ borderRadius: 10}} />
          <Bar dataKey="uv" stackId="a" fill="#f12762" maxBarSize={20} />
        </BarChart>
      </div>

      <div className="mb-5 bg-white p-5 rounded-xl shadow">
        <h1 className="text-lg font-semibold">Latency</h1>
      </div>
    </div>
  )
}